import { render, staticRenderFns } from "./Postgres95Summary.vue?vue&type=template&id=7c614893&"
import script from "./Postgres95Summary.vue?vue&type=script&lang=ts&"
export * from "./Postgres95Summary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports